import type { Guid } from '@apple/utils/primitive';

export const fileManagerQueryKeys = {
	all: ['user-files'],
	queue: ['user-files', 'queue'],
	userFileAccess: (documentId: Guid) => ['user-files', documentId],
	userFileRemove: (documentId: Guid) => ['user-file', 'remove', documentId],
	userFileUpload: ['user-file', 'upload'],
} as const;
